import { OpenModal } from 'domain/usecases/modal/redux/OpenModal';
import { iActionOpen, ModalTypes } from 'domain/interfaces/redux/modal/open';

export const openRequest = (payload: OpenModal.Params): iActionOpen => ({
  type: ModalTypes.OPEN,
  payload,
});
